import { Grid, Paper, Box, CircularProgress } from '@mui/material';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { getGiftById } from 'src/shared/services/giftService';
import { Gift } from 'src/modules/gift/models/gift';
import { useTranslation } from 'react-i18next';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useGlobals } from 'src/shared/contexts/appContext';
import { GiftDetailInvoice } from '../components/giftDetailInvoice';
import { GiftDetailOrderData } from '../components/giftDetailOrderData';
import { GiftDetailDonorInfo } from '../components/giftDetailDonorInfo';
import { GiftStatuses } from '../components/giftStatuses';
import { GiftDetailAttachment } from '../components/giftDetailAttachment';
import GiftDetailMarkAsHandledButton from '../components/giftDetailMarkAsHandledButton';

type GiftsDetailParams = {
  id: string;
};

export const GiftsDetailPage = () => {
  const params = useParams<GiftsDetailParams>();
  const { t } = useTranslation(['gift']);
  const { dateStamp } = useGlobals();

  const [gift, setGift] = useState<Gift>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getGiftById(params.id);
      ConsoleHelper.log(result.data, dateStamp);
      setGift(result.data);
      setLoading(false);
    };
    fetchData();
  }, [params.id, dateStamp]);

  return (
    <GridWrapper>
      <Grid item xs sx={{ display: 'flex', alignItems: 'center' }}>
        <MainContentHeader title={t('gift:detailHeader', { giftId: gift?.deposit_id })} isLoading={loading} />
        {gift && (
          <Box ml={1}>
            <GiftStatuses isPaid={gift.paid} isHandled={!!gift.isHandled} chipSize='small' />
          </Box>
        )}
      </Grid>
      <Grid item xs='auto'>
        {gift && <GiftDetailMarkAsHandledButton disabled={false} depositId={gift?.deposit_id} isHandled={!!gift.isHandled} />}
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 3 }}>
          {loading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
              <CircularProgress role='alert' aria-busy='true' aria-label={t('common:statusMessages.loading')} />
            </Box>
          )}
          {!loading && gift && (
            <Grid container spacing={3} sx={{ display: 'flex' }}>
              <Grid item xs={12} lg={8}>
                <GridWrapper>
                  <Grid item xs={12}>
                    <GiftDetailInvoice gift={gift} />
                  </Grid>
                  <Grid item xs={12}>
                    <GiftDetailDonorInfo gift={gift} />
                  </Grid>
                  {gift.order && (
                    <Grid item xs={12}>
                      <GiftDetailOrderData gift={gift} />
                    </Grid>
                  )}
                </GridWrapper>
              </Grid>
              <Grid item xs={12} lg={4} sx={{ display: 'flex', alignItems: 'stretch' }}>
                <GiftDetailAttachment depositId={gift.deposit_id} hasAttachemnet={gift.hasAttachment} />
              </Grid>
            </Grid>
          )}
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
